import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { useProduct } from './product-context';
import Icon from 'utils/icon';
import parse from 'html-react-parser';

const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  if (!content) return;

  return (
    <>
    {content.replace(/(<([^>]+)>)/gi, "") !== "" &&
      <div
        className="product-accordions__single-line border-b-1 border-grey-400 pt-[30px] pb-[30px]"
        onClick={toggleAccordion}
      >
        <div className="flex items-center justify-between cursor-pointer">
          <p className="text-s1 uppercase">{parse(title)}</p>
          <span className={`product-accordions__plus ${isOpen && 'hidden'}`}>
            <Icon id="plus" />
          </span>
          <span className={`product-accordions__minus ${!isOpen && 'hidden'}`}>
            <Icon id="minus" />
          </span>
        </div>
        <div
          className={`product-accordions__content text-h6 pt-[10px] lg:pt-[20px] ${
            !isOpen && 'hidden'
          }`}
        >
          {parse(content)}
        </div>
      </div>
      }
    </>
  );
};

const ProductAccordions = () => {
  const { activeProduct, data } = useProduct();
  const materialsAndCareContent = `${
    activeProduct.materials ? activeProduct.materials.value : ''
  }${activeProduct.care ? activeProduct.care.value : ''}`;

  const accordionData = [
    {
      title: data.accordionTitles.details,
      list: activeProduct.details?.value || null,
    },
    {
      title: data.accordionTitles.fit,
      list: activeProduct.fit?.value ? `${activeProduct.fit?.value}<button data-size-guide-trigger className="underline cursor-pointer" type="button">Fit + Size Guide</button>` : null,
    },
    {
      title: data.accordionTitles.materialsAndCare,
      list: materialsAndCareContent !== '' ? materialsAndCareContent : null,
    },
  ];

  const accordions = accordionData.map((accordion, index) => (
    <Accordion title={accordion.title} content={accordion.list} key={index} />
  ));

  if (!accordions.length) return null;

  return <div className="product-accordions">{accordions}</div>;
};

export default ProductAccordions;
